import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { CheckCircle } from "lucide-react";

export const PanUpdateModal = ({ panModal, setPanModal, newPan, setNewPan, handlePanUpdate }) => {
  const close = () => setPanModal({ open: false, partyName: "", currentPan: "", txnId: null });
  return (
    <Dialog open={panModal.open} onOpenChange={(open) => !open && close()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Update PAN for Party</DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div className="p-3 bg-slate-50 rounded-lg">
            <p className="text-sm"><strong>Party:</strong> {panModal.partyName}</p>
            <p className="text-sm">
              <strong>Current PAN:</strong>{" "}
              {panModal.currentPan || <span className="text-red-500">No PAN</span>}
            </p>
          </div>
          <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-sm text-blue-800">
              <strong>Note:</strong> Updating PAN will apply to ALL transactions for this party ({panModal.partyName}).
              Expected TDS rates will be recalculated based on the new PAN.
            </p>
          </div>
          <div>
            <Label className="text-sm font-medium">Enter PAN (10 characters)</Label>
            <Input
              value={newPan}
              onChange={(e) => setNewPan(e.target.value.toUpperCase())}
              placeholder="ABCDE1234F"
              maxLength={10}
              className="mt-2 font-mono uppercase"
              data-testid="pan-input"
            />
            <p className="text-xs text-slate-500 mt-1">
              4th character determines entity type: P=Individual, C=Company, F=Firm, H=HUF, etc.
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={close} data-testid="pan-cancel-btn">Cancel</Button>
          <Button onClick={handlePanUpdate} disabled={newPan.length !== 10} data-testid="pan-confirm-btn">
            <CheckCircle className="w-4 h-4 mr-2" />
            Update PAN
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
